export const PRESTIGE_COVER = 'prestige';
export const POPULAR_COVER = 'popular';
